import React, { useState } from 'react';
import { Button } from 'src/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from 'src/components/ui/dialog';
import { clsx } from 'clsx';
import { DeleteIcon } from 'src/assets/img/delete-icon';

export const DeletePopup = ({
  deleteBtnText = 'Yes, delete',
  disabled = false,
  deleteHandler = () => {},
  title = 'Delete?',
  description = (<>Are you sure you want to delete?</>) as React.ReactNode,
  descriptionHeader = '',
  submitBtnClassName = undefined,
  descriptionClassName = undefined,
  triggerIcon = (
    <div className="p-2 [&_svg]:hover:opacity-100 [&_svg>path]:hover:fill-error [&_svg]:opacity-50 [&_svg]:transition [&_svg>path]:transition duration-300">
      <DeleteIcon fill="#05050D" />
    </div>
  ),
}) => {
  const [open, setOpen] = useState(false);

  const deleteFunc = () => {
    deleteHandler();
    setOpen(false);
  };

  return (
    <Dialog onOpenChange={setOpen} open={open}>
      <DialogTrigger
        disabled={disabled}
        asChild
        className={clsx(disabled && 'pointer-events-none opacity-50', 'cursor-pointer')}
      >
        {triggerIcon}
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="text-start">{title}</DialogTitle>
        </DialogHeader>
        <div className="sub-title flex items-center gap-3.5">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19Z"
              stroke="#FF5151"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10 14H10.01V14.01H10V14Z"
              stroke="#FF5151"
              strokeWidth="2.25"
              strokeLinejoin="round"
            />
            <path
              d="M10 10V6"
              stroke="#FF5151"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>

          {descriptionHeader && (
            <h3 className="font-semibold text-base text-ebony">{descriptionHeader}</h3>
          )}
          <h4
            className={clsx(
              descriptionClassName,
              'text-delete font-medium text-base font-jamjuree',
            )}
          >
            {description}
          </h4>
        </div>

        <DialogFooter className="max-md:flex-row max-md:gap-2.5 !justify-center flex w-full pt-2">
          <DialogClose asChild>
            <Button
              style={{ width: 'auto' }}
              variant="outline"
              className="transparent black min-w-28"
            >
              Cancel
            </Button>
          </DialogClose>
          <Button
            style={{ width: 'auto' }}
            className={clsx(submitBtnClassName || 'red min-w-28')}
            onClick={deleteFunc}
          >
            {deleteBtnText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
